import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

// হোমপেজের সব ব্যানার/বিজ্ঞাপন একটাই API call-এ আসে এবং cache হয়ে থাকে।
// slot: HERO = মূল ক্যারোসেল, AFTER_* = সেকশনের পরের বিজ্ঞাপন।
export const BANNER_SLOTS: { key: string; labelBn: string; labelEn: string }[] = [
  { key: 'HERO',                     labelBn: 'মূল ব্যানার (ক্যারোসেল)',          labelEn: 'Main banner (carousel)' },
  { key: 'AFTER_HERO',               labelBn: 'মূল ব্যানারের পরে',                labelEn: 'After main banner' },
  { key: 'AFTER_FEATURES',           labelBn: 'ফিচার বারের পরে',                  labelEn: 'After features' },
  { key: 'AFTER_POPULAR_CATEGORIES', labelBn: 'পপুলার ক্যাটেগরির পরে',            labelEn: 'After popular categories' },
  { key: 'AFTER_HOT_DEALS',          labelBn: 'হট ডিলসের পরে',                    labelEn: 'After hot deals' },
  { key: 'AFTER_RECOMMENDED',        labelBn: 'রেকমেন্ডেডের পরে',                 labelEn: 'After recommended' },
  { key: 'AFTER_TRENDING',           labelBn: 'ট্রেন্ডিংয়ের পরে',                 labelEn: 'After trending' },
  { key: 'AFTER_SHOP_MORE',          labelBn: 'শপ মোরের পরে',                     labelEn: 'After shop more' },
  { key: 'AFTER_POPULAR_BRANDS',     labelBn: 'পপুলার ব্র্যান্ডসের পরে',           labelEn: 'After popular brands' }
];

@Injectable({ providedIn: 'root' })
export class BannerService {

  readonly api =
    'https://superbangladesh-api-1.onrender.com/api/banners';

  private cache$?: Observable<any[]>;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {

    if (!this.cache$) {

      this.cache$ = this.http.get<any[]>(this.api).pipe(

        map(res => Array.isArray(res) ? res : []),

        catchError(() => {
          // ফেইল হলে cache মুছে দিই, পরের বার আবার চেষ্টা হবে
          this.cache$ = undefined;
          return of([]);
        }),

        shareReplay({ bufferSize: 1, refCount: false })
      );
    }

    return this.cache$;
  }

  // পুরনো ব্যানারের slot NULL — সেগুলো HERO ধরা হয়
  getBySlot(slot: string): Observable<any[]> {

    return this.getAll().pipe(
      map(list =>
        list.filter(b => (b?.slot || 'HERO') === slot)
      )
    );
  }

  clear(): void {
    this.cache$ = undefined;
  }
}
